import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Card,
  Row,
  Container,
  Form,
  Spinner,
  Alert,
  ButtonGroup,
  Dropdown,
  FormGroup,
} from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Line, Radar } from "react-chartjs-2";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarDashboard";

import "../../css/onboarding.css";
import GraficoMedia from "../../components/evaluacion_desempenio/GraficoMedia";
import { getDashboardJefe } from "../../redux/evaluacion_desempenio/DashboardJefe/actions";
import CustomTableEval from "../../components/evaluacion_desempenio/CustomTableEval";
import { getEvaluationType } from "../../redux/evaluacion_desempenio/EvaluationType/actions";
import { getOrgs } from '../../redux/organization/actions';
import moment from "moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DashboardJefe = (props) => {
  const columnHigh = [
    {
      Header: "Alto desempeño",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.empleado && value.row.original.empleado !== ""
              ? value.row.original.empleado
              : "No hay evaluado"}
          </h6>
        </div>
      ),
    },
    {
      Header: "Punt.",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.puntaje && value.row.original.puntaje !== ""
              ? value.row.original.puntaje
              : ""}
          </h6>
        </div>
      ),
    },
  ];

  const columnMed = [
    {
      Header: "Desempeño int.",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.empleado && value.row.original.empleado !== ""
              ? value.row.original.empleado
              : "No hay evaluado"}
          </h6>
        </div>
      ),
    },
    {
      Header: "Punt.",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.puntaje && value.row.original.puntaje !== ""
              ? value.row.original.puntaje
              : ""}
          </h6>
        </div>
      ),
    },
  ];

  const columnLow = [
    {
      Header: "Bajo desempeño",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.empleado && value.row.original.empleado !== ""
              ? value.row.original.empleado
              : "No hay evaluado"}
          </h6>
        </div>
      ),
    },
    {
      Header: "Punt.",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <h6
            className={`${
              parseInt(value.row.original.puntaje) &&
              parseInt(value.row.original.puntaje) < 60
                ? "text-danger"
                : "text-muted"
            }`}
          >
            {value.row.original.puntaje && value.row.original.puntaje !== ""
              ? value.row.original.puntaje
              : ""}
          </h6>
        </div>
      ),
    },
  ];
  const { loading, dashboardJefe, dashboardJefeError } = useSelector(
    (store) => store.dashboardJefe
  );

  const { userRoles } = useSelector((store) => store.auth);
  const { orgs, loading: loadingOrgs} = useSelector(store => store.orgs);

  const {
    loading: loadingEval,
    evaluationTypes,
  } = useSelector((store) => store.evaluationType);

  const filters = [
    { id: "codigo_empleado", desc: "Código de evaluado" },
    { id: "nombre_empleado", desc: "Nombre de evaluado" },
    { id: "codigo_funcion", desc: "Código de función" },
    { id: "nombre_funcion", desc: "Nombre de función" },
    { id: "division", desc: "División" },
    // { id: "tipo_evaluacion", desc: "Tipo de evaluación" },
    // { id: "anio", desc: "Año" },
  ];

  const [filter, setFilter] = useState("");
  const [filterEval, setFilterEval] = useState("");
  const [isLoadedOrgs, setIsLoadedOrgs] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [anio, setAnio] = useState(moment().format("YYYY"));

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "codigo_empleado",
    desc: "Código de evaluado",
  });

  const getUserRolOne = () => {
    return userRoles.length > 0 ? userRoles[0] : '';
  }

  const [show, setShow] = useState(false);
  const [userRolFilter, setUserRolFilter] = useState(getUserRolOne());
  const dispatch = useDispatch();

  const _getDashboardJefe = (filt = filter, evalF = filterEval, view=userRolFilter, org=selectedOrg, filtro_anio=anio) =>
    dispatch(
      getDashboardJefe({
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
        tipo_evaluacion: evalF,
        view: view,
        organizacion_id: parseInt(org),
        filtro_anio: filtro_anio
      })
    );

    useEffect(() => {
      if(userRolFilter === 'administrador'){
        if (!isLoadedOrgs) {
          dispatch(getOrgs(2));
          setIsLoadedOrgs(true);
        }
      }
    }, [userRolFilter, isLoadedOrgs])
    

  useEffect(() => {
    if (userRoles.length > 0){
      setUserRolFilter(getUserRolOne());
    }
  }, [userRoles]);

  useEffect(() => {
    if (userRolFilter === '') return;
    if (userRolFilter === 'administrador' && selectedOrg === '') {
      return;
    }
    _getDashboardJefe();
  }, [dispatch, userRolFilter, selectedOrg, anio]);

  useEffect(() => {
    dispatch(getEvaluationType());
  }, [dispatch]);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    _getDashboardJefe(e.target.filter.value, filterEval);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  const onChangeUserRol = (userRol) => {
    setUserRolFilter(userRol); 
  }
  const getYears = () => {
    const years = Array.from({ length: 6 }, (_, i) => moment().year() - i);
    return years;
  }
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : (
          <>
            <Container fluid>
              <Col md={12}>
                <Card className="border-0">
                  <Card.Body>
                    <Row>
                      <Col md="3" className="mb-2 mb-sm-0">
                        <Card
                          // style={{ border: "1px solid #ced4da" }}
                          className="shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        >
                          <Card.Header
                            className="text-light text-uppercase text-center font-weight-bold"
                            style={{ backgroundColor: "#4ABD98" }}
                          >
                            <span>Promedio</span>
                          </Card.Header>
                          <Card.Body className="d-flex flex-wrap justify-content-between align-items-between">
                            {loading ? (
                              <div className="d-flex justify-content-center w-100">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="d-flex justify-content-center"
                                />
                              </div>
                            ) : (
                              <>
                                <Col sm="12" md="12" lg="12" xl="12">
                                  <Row className="d-flex flex-wrap justify-content-between align-items-between">
                                    <h2
                                      className={`${
                                        dashboardJefe &&
                                        dashboardJefe.total &&
                                        parseInt(dashboardJefe.total) &&
                                        parseInt(dashboardJefe.total) < 60
                                          ? "text-danger"
                                          : ""
                                      } font-weight-bold m-auto`}
                                    >
                                      {dashboardJefe &&
                                      dashboardJefe.total &&
                                      dashboardJefe.total > 0
                                        ? parseFloat(
                                            dashboardJefe.total
                                          ).toFixed(2)
                                        : 0}
                                    </h2>
                                  </Row>
                                </Col>

                                <Col
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  xl="12"
                                  className="d-flex flex-wrap justify-content-center align-items-center"
                                >
                                  <p className="footer2">
                                    <span
                                      className={`${
                                        dashboardJefe &&
                                        dashboardJefe.total &&
                                        parseInt(dashboardJefe.total) &&
                                        parseInt(dashboardJefe.total) < 60
                                          ? "text-danger"
                                          : ""
                                      } font-weight-bold footer2`}
                                    >
                                      {dashboardJefe &&
                                      dashboardJefe.desempenio_total
                                        ? dashboardJefe.desempenio_total
                                        : ""}
                                    </span>
                                  </p>
                                </Col>
                              </>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md="3" className="mb-2 mb-sm-0">
                        <Card
                          // style={{ border: "1px solid #ced4da" }}
                          className="h-100 shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        >
                          <CustomTableEval
                            columns={columnHigh}
                            data={
                              dashboardJefe &&
                              dashboardJefe.listado_empledo_desempenio
                                ? dashboardJefe.listado_empledo_desempenio
                                    .mejores_puntajes
                                : []
                            }
                            backgroundColor="#4ABD98"
                            title="Alto desempeño"
                          />
                        </Card>
                      </Col>
                      <Col md="3" className="mb-2 mb-sm-0">
                        <Card
                          // style={{ border: "1px solid #ced4da" }}
                          className="h-100 shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        >
                          <CustomTableEval
                            columns={columnMed}
                            data={
                              dashboardJefe &&
                              dashboardJefe.listado_empledo_desempenio
                                ? dashboardJefe.listado_empledo_desempenio
                                    .puntajes_intermedios
                                : []
                            }
                            backgroundColor="#17a2b8"
                            title="Desempeño intermedio"
                          />
                        </Card>
                      </Col>
                      <Col md="3" className="mb-2 mb-sm-0">
                        <Card
                          // style={{ border: "1px solid #ced4da" }}
                          className="h-100 shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        >
                          <CustomTableEval
                            columns={columnLow}
                            data={
                              dashboardJefe &&
                              dashboardJefe.listado_empledo_desempenio
                                ? dashboardJefe.listado_empledo_desempenio
                                    .peores_puntajes
                                : []
                            }
                            backgroundColor="#343a40"
                            title="Bajo desempeño"
                          />
                        </Card>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Form onSubmit={onSearch} className="mt-2 px-md-4">
                <Card className="shadow">
                  <Card.Body>
                    <Row>
                      <Col sm={12} md={userRolFilter === 'administrador' ? 4 : 6}>  
                        <FormGroup>
                          <Form.Label>Rol</Form.Label>
                          <Form.Control
                            onChange={(e) => onChangeUserRol(e.target.value)} 
                            as="select" 
                            className="col rounded-pill"
                            value={userRolFilter}>
                              <option value="" disabled selected>Seleccionar rol</option>
                              {
                                userRoles.map((rol) => (
                                  <option key={rol} value={rol}>
                                    {rol}
                                  </option>
                                ))
                              }
                          </Form.Control>
                        </FormGroup>
                      </Col>
                      {
                        userRolFilter === 'administrador' ? (
                          <Col sm={12} md={4}>
                            <Form.Group>
                              <Form.Label>Empresa</Form.Label>
                              <Row className="d-flex flex-wrap justify-content-start align-items-center">
                                <Col sm={loadingOrgs ? "10" : "12"}>
                                  <Form.Control
                                    as="select"
                                    id="org"
                                    name="org"
                                    className="col rounded-pill"
                                    value={selectedOrg}
                                    onChange={(e) => setSelectedOrg(e.currentTarget.value)}
                                  >
                                    <option
                                      className="text-muted"
                                      value=""
                                      selected
                                      disabled
                                    >
                                      Selecionar empresa
                                    </option>
                                    {orgs.length > 0 &&
                                      orgs.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.nombre}
                                        </option>
                                      ))}
                                  </Form.Control>
                                </Col>
                                {loadingOrgs ? (
                                  <Col sm={1}>
                                    <Spinner animation="border" size="sm" />
                                  </Col>
                                ) : null}
                              </Row>
                            </Form.Group>
                          </Col>
                        ) : null
                      }
                      <Col sm={12} md={4}>
                        <Form.Label>Año</Form.Label>
                        <Form.Control
                          as="select"
                          id="anio"
                          name="anio"
                          className="col rounded-pill"
                          value={anio}
                          onChange={(e) => setAnio(e.currentTarget.value)}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar año
                          </option>
                          {getYears().map((item) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                    </Row>
                    <Row className="mr-1">
                      <Col sm={12} md={7}>
                        <Form.Group>
                          <Form.Label>Búsqueda por: {tipoBusqueda.desc}</Form.Label>
                          <div className="d-flex align-items-center">
                            <Form.Control
                              name="filter"
                              id="filter"
                              placeholder="Buscar"
                              className="rounded-pill form-control-sm"
                              type="search"
                              defaultValue={filter} />
                            <ButtonGroup>
                              <Dropdown className="mx-1">
                                <Dropdown.Toggle
                                  variant="light"
                                  className="btn-sm font rounded-pill"
                                >
                                  <i className="material-icons">filter_list</i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {filters.map((item) => (
                                    <Dropdown.Item
                                      onClick={() => setTipoBusqueda(item)}
                                      key={item.id}
                                    >
                                      {item.desc}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </ButtonGroup>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={5}>
                        <Form.Group>
                          <Form.Label>Tipo de evaluación</Form.Label>
                          <Row className="d-flex flex-wrap justify-content-start align-items-center">
                            <Col sm={loading ? "10" : "12"}>
                              <Form.Control
                                as="select"
                                id="tipo_evaluacion"
                                name="tipo_evaluacion"
                                className="col rounded-pill"
                                value={filterEval}
                                onChange={(e) => {
                                  e.preventDefault();
                                  setFilterEval(e.currentTarget.value);
                                  _getDashboardJefe(
                                    filter,
                                    e.currentTarget.value
                                  );
                                }}
                              >
                                <option
                                  className="text-muted"
                                  value=""
                                  selected
                                  disabled
                                >
                                  Selecionar tipo de evaluación
                                </option>
                                {evaluationTypes.length > 0 &&
                                  evaluationTypes.map((item) => (
                                    <option key={item.id} value={item.nombre}>
                                      {item.nombre}
                                    </option>
                                  ))}
                              </Form.Control>
                            </Col>
                            {loading ? (
                              <Col sm={1}>
                                <Spinner animation="border" size="sm" />
                              </Col>
                            ) : null}
                          </Row>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {/* <Row>
                  <Col sm={12} md={8}>
                    <Form.Group class="mr-1">
                      <Form.Label>Búsqueda por: {tipoBusqueda.desc}</Form.Label>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          name="filter"
                          id="filter"
                          placeholder="Buscar"
                          className="rounded-pill form-control-sm"
                          type="search"
                          defaultValue={filter} />
                        <ButtonGroup>
                          <Dropdown className="mx-1">
                            <Dropdown.Toggle
                              variant="light"
                              className="btn-sm font rounded-pill"
                            >
                              <i className="material-icons">filter_list</i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filters.map((item) => (
                                <Dropdown.Item
                                  onClick={() => setTipoBusqueda(item)}
                                  key={item.id}
                                >
                                  {item.desc}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </ButtonGroup>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={4}>
                    <Form.Group>
                      <Form.Label>Tipo de evaluación</Form.Label>
                      <Row className="d-flex flex-wrap justify-content-start align-items-center">
                        <Col sm={loading ? "10" : "12"}>
                          <Form.Control
                            as="select"
                            id="tipo_evaluacion"
                            name="tipo_evaluacion"
                            className="col rounded-pill"
                            value={filterEval}
                            // disabled={loadingOrgs}
                            onChange={(e) => {
                              e.preventDefault();
                              setFilterEval(e.currentTarget.value);
                              _getDashboardJefe(
                                filter,
                                e.currentTarget.value
                              );
                            }}
                          >
                            <option
                              className="text-muted"
                              value=""
                              selected
                              disabled
                            >
                              Selecionar tipo de evaluación
                            </option>
                            {evaluationTypes.length > 0 &&
                              evaluationTypes.map((item) => (
                                <option key={item.id} value={item.nombre}>
                                  {item.nombre}
                                </option>
                              ))}
                            {/* <option
                              className="text-muted"
                              value=""
                              selected
                            >
                              0°
                            </option>
                            <option
                              className="text-muted"
                              value=""
                              selected
                            >
                              90°
                            </option>
                            <option
                              className="text-muted"
                              value=""
                              selected
                            >
                              180°
                            </option>
                          </Form.Control>
                        </Col>
                        {loading ? (
                          <Col sm={1}>
                            <Spinner animation="border" size="sm" />
                          </Col>
                        ) : null}
                      </Row>
                    </Form.Group>
                  </Col>
                </Row> */}
              </Form>

              <Row className="px-2">
                <Col md={12}>
                  <Row className="my-3 ml-2 mr-2">
                    <Col md="12" className="mb-3 mb-sm-0">
                      <Card className="shadow">
                        <Card.Body>
                          <Col className="d-flex flex-wrap justify-content-center align-items-between font-weight-bold text-muted">
                            <span className="text-center">
                              Distribución de resultados de evaluación en número
                              de evaluados
                            </span>
                          </Col>
                          <Col
                            md="12"
                            className="py-2 mx-auto"
                            style={{ overflowX: "auto" }}
                          >
                            <GraficoMedia dashboardJefe={dashboardJefe} />
                          </Col>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="px-2">
                <Col md={6}>
                  <Row className="my-3 ml-2 mr-2">
                    <Col md="12" className="mb-3 mb-sm-0">
                      <Card
                        className="shadow"
                        // style={{ border: "1px solid #ced4da" }}
                      >
                        <Card.Body>
                          {/* <h5 className="text-muted">Cumplimiento de Actividades</h5>
                    {loading ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : (
                      <Bar
                        height={155}
                        data={encuestasMensualData}
                        options={{
                          fill: false,
                          interaction: {
                            intersect: false,
                          },
                          responsive: true,
                          legend: {
                            display: false,
                          },
                          // scales:{
                          //   x:{ stacked: true},
                          //   y:{ stacked: true}
                          // },
                          radius: 0,
                        }}
                      />
                    )} */}
                          <Line
                            options={{
                              fill: false,
                              interaction: {
                                intersect: false,
                              },
                              responsive: true,
                              plugins: {
                                legend: {
                                  display: false,
                                },
                                title: {
                                  display: true,
                                  text: "Puntuación trimestral promedio",
                                },
                              },
                              // scales:{
                              //   x:{ stacked: true},
                              //   y:{ stacked: true}
                              // },
                              radius: 0,
                            }}
                            data={
                              dashboardJefe.puntuacion_trimestral_promedio
                                ? dashboardJefe.puntuacion_trimestral_promedio
                                : {}
                            }
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <Row className="my-3 ml-2 mr-2">
                    <Col md="12" className="mb-3 mb-sm-0">
                      <Card
                        className="shadow"
                        // style={{ border: "1px solid #ced4da" }}
                      >
                        <Card.Body>
                          {/* <h5 className="text-muted">Cumplimiento de Actividades</h5>
                    {loading ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : (
                      <Bar
                        height={155}
                        data={encuestasMensualData}
                        options={{
                          fill: false,
                          interaction: {
                            intersect: false,
                          },
                          responsive: true,
                          legend: {
                            display: false,
                          },
                          // scales:{
                          //   x:{ stacked: true},
                          //   y:{ stacked: true}
                          // },
                          radius: 0,
                        }}
                      />
                    )} */}
                          <Bar
                            options={{
                              fill: false,
                              interaction: {
                                intersect: false,
                              },
                              responsive: true,
                              plugins: {
                                legend: {
                                  display: false,
                                },
                                title: {
                                  display: true,
                                  text: "Comparación entre evaluados",
                                },
                              },
                              // scales:{
                              //   x:{ stacked: true},
                              //   y:{ stacked: true}
                              // },
                              // radius: 0,
                            }}
                            data={
                              dashboardJefe &&
                              dashboardJefe.comparacion_empleados
                                ? dashboardJefe.comparacion_empleados
                                : null
                            }
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="px-2">
                <Col md={6}>
                  <Row className="my-3 ml-2 mr-2">
                    <Col md="12" className="mb-3 mb-sm-0">
                      <Card
                        className="shadow"
                        // style={{ border: "1px solid #ced4da" }}
                      >
                        <Card.Body>
                          {/*
                    {loading ? (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : (
                      <Bar
                        height={155}
                        data={encuestasMensualData}
                        options={{
                          fill: false,
                          interaction: {
                            intersect: false,
                          },
                          responsive: true,
                          legend: {
                            display: false,
                          },
                          // scales:{
                          //   x:{ stacked: true},
                          //   y:{ stacked: true}
                          // },
                          radius: 0,
                        }}
                      />
                    )} */}
                          <Radar
                            options={{
                              fill: false,
                              interaction: {
                                intersect: false,
                              },
                              responsive: true,
                              plugins: {
                                legend: {
                                  display: true,
                                },
                                title: {
                                  display: true,
                                  text: "Distibución por competencia",
                                },
                              },
                              // scales:{
                              //   x:{ stacked: true},
                              //   y:{ stacked: true}
                              // },
                              radius: 0,
                            }}
                            data={
                              dashboardJefe.Dasboard_competencias
                                ? dashboardJefe.Dasboard_competencias
                                : {}
                            }
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </>
        )}
        {!!dashboardJefeError && (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            {dashboardJefeError}
          </Alert>
        )}
      </div>
    </>
  );
};

export default DashboardJefe;
